class HelpWrapperFilter {
    constructor(wrapperClass = 'help-wrapper', urlParam = 'type', toggleClass = 'all-help-js') {
        this.wrapperClass = wrapperClass;
        this.urlParam = urlParam;
        this.toggleClass = toggleClass;
        this.$helpWrappers = $(`.${this.wrapperClass}`);
        this.$toggleButton = $(`.${this.toggleClass}`);
        this.init();
    }

    // 初始化
    init() {
        const typeIndex = parseInt(new URLSearchParams(window.location.search).get(this.urlParam), 10);
        if (typeIndex >= 1 && typeIndex <= this.$helpWrappers.length) {
            this.$toggleButton.show()
            this.$helpWrappers.hide().eq(typeIndex - 1).show();
        }

        this.$toggleButton.on('click', () => {
            this.$helpWrappers.show(); // 显示所有 help-wrapper
            this.$toggleButton.hide();  // 隐藏按钮
        });
    }
}

// 页面加载完成后初始化
document.addEventListener('DOMContentLoaded', function() {
    new HelpWrapperFilter(); // 默认使用 .help-wrapper 和 ?type 参数，all-help-js 是按钮类名
});
